<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="">
      <!--      <div class="row1" v-for="(row,i) in list"  v-if="i<1">-->
      <!--        <img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />-->
      <!--      </div>-->
      <!--      <div class="row3">-->
      <!--        <img  v-rblink="{name:'NewsList',query:{cate_id:row.id}}" v-for="(row,i) in list"  v-if="i>=1&&i<6" :src="row.pic_url" />-->
      <!--      </div>-->
      <!--      <div class="row1" style="margin: 0px 30px;" v-for="(row,i) in list"  v-if="i==6">-->
      <!--        <img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />-->
      <!--      </div>-->

      <div class="row-box">
        <div class="row-left">
          <div :class="params.weiyuanhui_id == area.id ? 'left-li left-li-active' : 'left-li'" v-for="area in areaList"
               :key="area.id" @click="onSelectLeft(area)">{{ area.province }}
          </div>
        </div>
        <div class="row-right">
          <div v-if="fenhuishow">
        <div class="news-content" v-html="fenhuiRow.content"></div>
          </div>
          <van-list velse v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="right-li flex-start" v-for="(row,i) in list" :key="i">
              <div class="right-li-img">
<!--                <img src="../../../assets/images/other/bg-shangwuzhaoshang.png" alt="">-->
                <img :src="row.wechat_pic_url" alt="" @click="onPreview(row)">
                <div>加我企业微信</div>
              </div>
              <div class="right-li-line"></div>
              <div class="right-li-user">
                <div class="right-user-one">
                  <div class="right-user-label">姓名</div>
                  <div class="right-user-value">{{ row.name }}</div>
                </div>
                <div class="right-user-one">
                  <div class="right-user-label">电话</div>
                  <div class="right-user-value">{{ row.phone }}</div>
                </div>
                <div class="right-user-one">
                  <div class="right-user-label">职务</div>
                  <div class="right-user-value" v-if="row.area_type == 1">{{ row.province }}负责人</div>
                  <div class="right-user-value" v-else>{{ row.city }}负责人</div>
                </div>
              </div>

              <div class="right-li-sign right-li-sign-province" v-if="row.area_type == 1">{{ row.province }}</div>
              <div class="right-li-sign right-li-sign-city" v-else>{{ row.city }}</div>
            </div>
          </van-list>
        </div>
      </div>


      <van-popup v-model="showCert" style="width: 80%; height: auto ; text-align: center">
        <img :src="certUrl"  style="width: 100%; text-align: center; height: auto"  />
        <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
        <van-button v-else @click="appDownload" style="margin: 10px auto; text-align: center " type="default" round>点击下载图片</van-button>
      </van-popup>
    </div>
  </div>
</template>
<style scoped>
.row-box {
  display: flex;
  justify-content: flex-start;
}

.right-user-one {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: .22rem;
}

.right-user-label {
  margin-right: .2rem;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.right-user-value {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
}

.row-left {
  height: 100vh;
  width: 105px;
  min-width: 105px;

  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  background: #F5F5F5;
  text-align: center;
  overflow-y: scroll;
}

.left-li {
  height: 50px;
  line-height: 50px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.left-li-active {
  background: #FFFFFF;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F7B500;
}

.row-right {
  height: 100vh;
  width: 100%;
  background: #fff;
  overflow-y: scroll;
}

.right-li-img img {
  width: 60px;
  height: 60px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}

.right-li {
  margin: .2rem .2rem 0;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.05);
  padding: .3rem .2rem;
  position: relative;
  background: #fff;
  border-radius: 4px;
}

.right-li-sign-province {
  background: linear-gradient(133deg, #FA6400 0%, #FD9D00 100%);
}

.right-li-sign-city {
  background: linear-gradient(130deg, #7798FF 0%, #D4E1FF 100%);
}

.right-li-sign {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 8px 4px 8px 0px;
  color: #fff;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  padding: 2px 10px;
}

.right-li-img {
  text-align: center;
  padding: 5px;
}

.right-li-img div {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.right-li-line {
  width: 1px;
  height: 62px;
  background: #E5E5E5;
  margin: 0 .3rem 0 .2rem;
}

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}

.row1 {
  /*padding: 10px;*/
  margin: 0 10px;
}

.row1 img {
  width: 100%;
  margin: 10px 0 0 0;
}

.row3 {
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  margin: 10px 10px;
  /*flex-wrap: wrap;*/
}

.row3 img {
  float: left;
  width: calc(33.33% - 10px);
  margin: 0 10px 10px 0;
}


.news-content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 20px;
  color: rgba(34, 34, 34, 1);
  line-height: 28px;
}

.news-content >>> img {
  max-width: 100% !important;
}

.news-content >>> video {
  max-width: 100% !important;
}

</style>

<script>
import Vue from "vue";
import {Tab, Tabs, List, PullRefresh, Toast, ImagePreview} from "vant";

Vue.use(Tab)
    .use(Tabs)
    .use(PullRefresh)
    .use(List)
    .use(ImagePreview)
    .use(Toast);

export default {
  name: "JiGouShezhi",
  components: {},

  data: function () {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      showCert: false,
      fenhuishow: true,
      certUrl: '',
      filename: '',
      active: 0,
      activeTab: [],
      list: [],
      areaList: [],
      params: {
        pageNo: 1,
        pageSize: 10,
        weiyuanhui_id: 3530,
      },
      isApp:window.isApp(),
      fenhuiRow:{

      }
    };
  },
  filters: {},
  mounted() {
    document.title = "机构设置";
    this.fetch();
    this.getAreaList();
    this.getFenhuiDetail();
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
          "/api/weiyuanhui/wyhAdminList",
          that.params,
          res => {
            that.loading = false;
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }
            if (res.data.list.length == 0) {
              that.finished = true;
            }

            that.params.pageNo += 1;
          },
          res => {
            Toast(res.msg);
          }
      );
    },

    appDownload(){
      let that = this;
      console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: that.filename,
          url:that.certUrl,
        }
      });
    },

    onPreview(row) {
      // ImagePreview([pic])

      console.log('onPreview', row)
      this.filename = row.name + '的企业微信'
      this.certUrl = row.wechat_pic_url

      this.showCert = true
    },

    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo", this.params.pageNo);
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },


    getFenhuiDetail() {
      let that = this;
      that.$api.post('/api/cms/detail', {
        id: 595
      }, (res) => {
        that.fenhuiRow = res.data.data;  
      }, (res) => {
        Toast.fail(res.msg);
      })
    },



    onSelectLeft(area) {
      if(area.id == '3530'){

        this.fenhuishow = true;
        // rbLink({
        //   name: "NewsDetail",
        //   query: {
        //     id:595
        //   }
        // });
 
      }else{
        this.fenhuishow = false
      }
      this.params.pageNo = 1;
      this.list = []
      this.params.weiyuanhui_id = area.id

      this.loading = true;
      this.finished = false;
      this.fetch();
    },

    getAreaList() {
      let that = this;
      that.$api.get(
          "/api/weiyuanhui/wyhProvinceAreaList",
          {}, res => {
            that.areaList = res.data
          },
          res => {
            Toast(res.msg);
          });
    },
  }
};
</script>



// WEBPACK FOOTER //
// Jigoushezhi.vue?599060d2